/* eslint-disable */
export default {
    resume_Accepteded_File_Format: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.txt,.rtf,.doc',
}